import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
interface DialogData {
  permisoCredito: boolean,
  permisoTC: boolean,
  permisoMixto: boolean,
}
@Component({
  selector: 'app-modal-tipo-producto',
  templateUrl: './modal-tipo-producto.component.html',
  styleUrls: ['./modal-tipo-producto.component.scss']
})
export class ModalTipoProductoComponent implements OnInit {
  productSelected=1
  productForm:FormGroup
  constructor(public dialogRef: MatDialogRef<ModalTipoProductoComponent>,private formBuilder: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    let tipoDefault=!this.data.permisoCredito?'tarjeta_credito':'credito_fiduciario'
    this.productForm = formBuilder.group({
      dpi: ['', Validators.compose([Validators.pattern(/^\d{13}$/), Validators.required])],
      tipoPrecalificacion: [tipoDefault, Validators.compose( [Validators.required])],
    })
   }

  ngOnInit(): void {
  }
  goToDatosGenerales(){
    this.dialogRef.close(
      {
                dpi: this.productForm.get('dpi').value,
                tipopreca: this.productForm.get('tipoPrecalificacion').value,
                flowType: "DEBTOR",
              }
    ) 
  }
  selectProduct(product){
    this.productSelected=product
  }
}
